import { c as _c } from "react/compiler-runtime";
import { CONTACT_STATEMENT_TYPE, CONTACT_STATEMENT_TYPES } from "@/helpers/Types";
import UserPageIdentityAddStatementsTypeButton from "@/components/user/identity/statements/utils/UserPageIdentityAddStatementsTypeButton";
export default function UserPageIdentityAddStatementsContactItems(t0) {
  const $ = _c(5);
  const {
    activeType,
    setContactType
  } = t0;
  let t1;
  if ($[0] !== activeType || $[1] !== setContactType) {
    t1 = CONTACT_STATEMENT_TYPES.map((type, i) => <UserPageIdentityAddStatementsTypeButton key={type} statementType={type} isActive={activeType === type} isFirst={i === 0} isLast={i === CONTACT_STATEMENT_TYPES.length - 1} onClick={() => setContactType(type)} />);
    $[0] = activeType;
    $[1] = setContactType;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t1) {
    t2 = <div className="tw-mt-8"><span className="tw-isolate tw-inline-flex tw-rounded-md tw-shadow-sm tw-w-full">{t1}</span></div>;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
}